var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Layout',[_c('PageHeader',{attrs:{"title":_vm.title,"items":_vm.items}}),_c('DoctorQueueTable',{attrs:{"permission-key":"other_patients","endpoint":"/theaterpatients","action-path":"/theatertreatment","action-label":"Treatment","no-permission-text":"You have no permission to View Theater Patients"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }